import * as Effects from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import fireToastError from '../../actions/toasts/fireToastError'
import i18n from '../../i18n'
import { UpdateLimitType } from '../../models/Limit'
import updateLimit from '../../models/Limit/updateLimit'
import { isLicenseValid } from '../../reducers/userAccount/selectors/license'
import { getUserId } from '../../reducers/userAccount/selectors/userAccount'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'

export default function*(type: UpdateLimitType) {
  const premium = yield Effects.select(isLicenseValid)
  if (premium) {
    return
  }
  try {
    const actionNames = fetchActionsName(ActionNames.UpdateLimits)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, updateLimit),
      ),
    ])

    const userId = yield Effects.select(getUserId)

    yield Effects.call(service, userId, type)
  } catch (e) {
    console.error(e)
    yield Effects.put(fireToastError(i18n.t('error_server_response_2')))
  }
}
